import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';

const API_URL = import.meta.env.VITE_API_URL || '';

export default function CreateAdmin() {
    const { token, admin } = useAuthStore();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        fullName: '',
        role: 'municipal_admin',
        provinceId: '',
        municipalityId: ''
    });

    const createMutation = useMutation({
        mutationFn: async () => {
            const res = await fetch(`${API_URL}/admin/admins`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password,
                    full_name: formData.fullName,
                    role: formData.role,
                    province_id: formData.provinceId || null,
                    municipality_id: formData.municipalityId || null
                })
            });
            if (!res.ok) throw new Error('Error al crear admin');
            return res.json();
        },
        onSuccess: () => navigate('/')
    });

    const availableRoles = admin?.role === 'super_admin'
        ? ['super_admin', 'province_admin', 'municipal_admin', 'staff']
        : ['municipal_admin', 'staff'];

    return (
        <div>
            <div className="page-header">
                <h2>👤 Crear Administrador</h2>
            </div>

            <div className="card" style={{ maxWidth: '500px' }}>
                <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                        className="form-input"
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Contraseña</label>
                    <input
                        className="form-input"
                        type="password"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Nombre Completo</label>
                    <input
                        className="form-input"
                        value={formData.fullName}
                        onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Rol</label>
                    <select
                        className="form-input"
                        value={formData.role}
                        onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                    >
                        {availableRoles.map(role => (
                            <option key={role} value={role}>
                                {role.replace('_', ' ').toUpperCase()}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    className="btn btn-primary"
                    onClick={() => createMutation.mutate()}
                    disabled={createMutation.isPending}
                >
                    {createMutation.isPending ? 'Creando...' : 'Crear Administrador'}
                </button>
            </div>
        </div>
    );
}
